/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import '../../css/event210621.css';

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import moment from "moment";
// import axios from "axios";

class ContentItem6 extends PureComponent {
  state = {
    alram: 0,
  };
  _goContent = (contentSerial) => {
    const { setContentSerial } = this.props;
    setContentSerial(contentSerial);
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    //console.log(this.props.location.pathname)
    //console.log(nextProps.location)
    return this.props.childProps.reset !== nextProps.childProps.reset;
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    ////console.log(nextProps)

    if (this.props.childProps.reset !== nextProps.childProps.reset) {
      this.setState({
        alram: 0,
      });
    }
  };

  _onExpect = async () => {
    const { contentSerial, img, title, alramFlag, _expect, grade } =
      this.props.childProps;

    const a = await _expect(contentSerial, img, title, alramFlag, grade);
    console.log(a, contentSerial);
    if (parseInt(a) === 100) {
      this.setState({
        alram: parseInt(a),
      });
    }
  };
  _onExpectApi = () => {};
  render() {
    const { contentSerial, img, comment, title, alramFlag, reset } =
      this.props.childProps;
    const { alram } = this.state;
    const { imgUrl } = this.props;

    //onsole.log(reset)
    return (
      <Fragment>
        {reset ? (
          <div className="item">
            <button type="button" className="btn none">
              보관함
            </button>
            <div className="ani">
              <div className="thumb">
                <a
                  onClick={() => this._goContent(contentSerial)}
                  style={{ cursor: 'pointer' }}
                >
                  <img src={img} />
                </a>
              </div>
              <div className="info">
                <p className="date">
                  <img
                    src={imgUrl + '/img/event/event220916/ico_live.png'}
                    alt="LIVE"
                  />{' '}
                  {comment}
                </p>
                <p className="subject">
                  <a
                    onClick={() => this._goContent(contentSerial)}
                    style={{ cursor: 'pointer' }}
                  >
                    {title}
                  </a>
                </p>
              </div>
            </div>
            <img
              src={imgUrl + '/img/event/event220916/list_img.png'}
              className="img_web bg"
            />
            <img
              src={imgUrl + '/img/event/event220916/m_list_img.png'}
              className="img_m bg"
            />
          </div>
        ) : alramFlag === 0 && alram !== 100 ? (
          <div className="item">
            <button type="button" className="btn" onClick={this._onExpect}>
              보관함
            </button>
            <img
              src={imgUrl + '/img/event/event220916/list_img.png'}
              className="img_web"
            />
            <img
              src={imgUrl + '/img/event/event220916/m_list_img.png'}
              className="img_m"
            />
          </div>
        ) : alram === 100 || alramFlag === 100 ? (
          <div className="item">
            <button type="button" className="btn none">
              보관함
            </button>
            <div className="ani">
              <div className="thumb">
                <a
                  onClick={() => this._goContent(contentSerial)}
                  style={{ cursor: 'pointer' }}
                >
                  <img src={img} />
                </a>
              </div>
              <div className="info">
                <p className="date">
                  <img
                    src={imgUrl + '/img/event/event220916/ico_live.png'}
                    alt="LIVE"
                  />{' '}
                  {comment}
                </p>
                <p className="subject">
                  <a
                    onClick={() => this._goContent(contentSerial)}
                    style={{ cursor: 'pointer' }}
                  >
                    {title}
                  </a>
                </p>
              </div>
            </div>
            <img
              src={imgUrl + '/img/event/event220916/list_img.png'}
              className="img_web bg"
            />
            <img
              src={imgUrl + '/img/event/event220916/m_list_img.png'}
              className="img_m bg"
            />
          </div>
        ) : null}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(ContentItem6));
